import Cookies from "js-cookie";
import { API_ENDPOINTS } from "../../../api/endpoints";

export const sendGroupToAPI = async (group) => {
  const jwtToken = Cookies.get("token");

  try {
    const response = await fetch(API_ENDPOINTS.externa.bookings, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authentication-Token": jwtToken,
      },
      body: JSON.stringify(group),
    });

    if (!response.ok) {
      const errorResponse = await response.text();
      throw new Error(`Error en la API: ${response.statusText}. Detalles: ${errorResponse}`);
    }

    const result = await response.json();
    return result.id;
  } catch (err) {
    console.error("Error al enviar el grupo:", err);
    throw err;
  }
};
